import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../assets/styles/Franchise.css';
import config from '../config.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReqfranchiseAssign from './Assign/ReqfranchiseAssign';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import ReqclientAssign from './Assign/ReqclientAssign.js';

const Request = ({ pageName }) => {
    const [clientData, setClientData] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [isclientpopup, setIsclientpopup] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isFranchise, setIsFranchise] = useState(false);
    const [franchiseData, setFranchiseData] = useState(null);
    const [isclientassign, setIsclientassign] = useState(false);
    const [isFranchiseAssign, setIsFranchiseAssign] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(24);

    const label = [
        { id: 1, label: "Facial attendance" },
        { id: 2, label: "Gender classification" },
        { id: 3, label: "Unknown tracking" },
        { id: 4, label: "People In / Out" },
        { id: 5, label: "Crowd detection" },
        { id: 6, label: "Trespass detection" },
        { id: 7, label: "Tripwire detection" },
        { id: 8, label: "Vehicle In / Out" },
        { id: 9, label: "ANPR" },
        { id: 10, label: "PPE detection" },
        { id: 11, label: "Camara tempering" }
    ];

    const handleCloseFranchise = () => {
        setIsFranchise(false);
        setIsFranchiseAssign(false)
        fetchRequests();

    }
    const handleCloseclient = () => {
        setIsclientpopup(false);
        setIsclientassign(false);
        fetchRequests();
    }

    const fetchRequests = async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getrequests`);
        
            const responseData = await response.json();
            setClientData(responseData.data);
        } catch (err) {
            toast.error('fetching client data ,network error');
        }
    };
    useEffect(() => { fetchRequests(); }, []);

    const filteredData = clientData.filter(
        item =>
            (item.name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
            (item.client?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
            (item.type?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
            (item.request_type?.toLowerCase() || "").includes(searchTerm.toLowerCase())

    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const handleopenFranchise = async (id) => {
        try {
            const response = await axios.get(`${config.apiBaseUrl}/admin/getfranchByIdreq/${id}`);
            setFranchiseData(response.data.data);
            setIsFranchise(true);
        } catch (error) {
            console.log('Failed to fetch franchise data. Please try again later.');
        }
    };
    const handleopenclient = async (id) => {
        try {
            const response = await axios.get(`${config.apiBaseUrl}/admin/getclintIdreq/${id}`);
            setSelectedClient(response.data.data);
            setIsclientpopup(true);
        } catch (error) {
            console.log('Failed to fetch client data. Please try again later.');
        }
    };

    const handleApproveFranchise = async (request_id, franchise_id, status) => {
        try {
            const response = await axios.put(`${config.apiBaseUrl}/admin/updatestatus`,
                { request_id, franchise_id, status }
            );
            toast.success(response.data.message);
            setTimeout(() => {
                if (status === 'Denied') {
                    handleCloseFranchise();
                } else if (status === 'Approved') {
                    setIsFranchiseAssign(true);
                }
                fetchRequests();
            }, 2500);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Failed to franchise status';
            toast.error(errorMessage);
        }
    };


    const handleApproveclient = async (request_id, client_id, status) => {
        try {
            const response = await axios.put(
                `${config.apiBaseUrl}/admin/updatestatusclient`,
                { request_id, client_id, status }
            );
            toast.success(response.data.message);
            setTimeout(() => {
                if (status === 'Denied') {
                    handleCloseclient();
                } else if (status === 'Approved') {
                    setIsclientassign(true);
                }
                fetchRequests();
            }, 2500);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Failed to update client status';
            toast.error(errorMessage);
        }
    };


    return (
        isclientassign === true ? (
            <div className=''>
                <ReqclientAssign closePopup={handleCloseclient} selectedClient={selectedClient} pageName={pageName} />
            </div>
        )
            : (
                isFranchiseAssign === true ? (
                    <div className=''>
                        <ReqfranchiseAssign closePopup={handleCloseFranchise} franchisedata={franchiseData} pageName={pageName} />
                    </div>
                )
                    : (
                        <div className='camera-cm'>
                            <ToastContainer />
                            <div className='row'>
                                <div className='col-6 col-md-6 col-lg-5'>
                                    <div className="search-bar">
                                        <FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} />
                                        <input
                                            type="search"
                                            placeholder="Search"
                                            aria-label="Search"
                                            className='search-bar-input'
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='col-6 col-md-6 col-lg-7 d-flex justify-content-end'>
                                    <div className="dropdownreq">
                                        <div className='col-12 col-md-6 col-lg-12'>
                                            <div className="">
                                                <select
                                                    className='input-formsreqfilter'
                                                    name="country"
                                                    onChange={(e) => {
                                                        if (e.target.value === "All") {
                                                            setSearchTerm("");
                                                        } else {
                                                            setSearchTerm(e.target.value);
                                                        }
                                                    }}
                                                >
                                                    <option value="" disabled>Filter by</option>
                                                    <option value="All">All</option>
                                                    <option value="Plan Update">Plan Update</option>
                                                    <option value="License Upgrade">License Upgrade</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="overall-containerf mt-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="table-th">
                                            <tr>
                                                <th>S.no</th>
                                                <th>Request ID</th>
                                                <th>Name</th>
                                                <th>From</th>
                                                <th>Type</th>
                                                <th>Date</th>
                                                <th>Review</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tbody-responsive'>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.request_id}</td>
                                                        <td>{item.client_id ? item.name : item.franchise_name}</td>
                                                        <td>{item.client_id ? 'Direct client' : 'Franchise'}</td>
                                                        <td>{item.request_type}</td>
                                                        <td>{new Date(item.created_at).toISOString().split('T')[0]}</td>
                                                        <td>
                                                            <span
                                                                className="clientviewpopup"
                                                                onClick={() => {
                                                                    handleopenFranchise(item.franchise_id);
                                                                    handleopenclient(item.client_id);
                                                                }}
                                                            >
                                                                Review
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No matching records found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div className="pagination mt-2 d-flex justify-content-end">
                                <button className='leftcherve' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><FontAwesomeIcon icon={faChevronLeft} /></button>
                                {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                    <button key={index} onClick={() => paginate(index + 1)} className={`paginationcnt ${currentPage === index + 1 ? 'active' : ''}`}>
                                        {index + 1}
                                    </button>
                                ))}
                                <button className='rightcherve' onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                            {isFranchise && (
                                <div className="Franchise-overlay">
                                    <ToastContainer />
                                    <div className="Franchise-content">
                                        <p className="text-end mb-0 mt-2">
                                            <FontAwesomeIcon className="Franchise-close" onClick={handleCloseFranchise} icon={faXmark} />
                                        </p>
                                        <h5 className="mb-3">Franchise License Upgrade</h5>
                                        <div className="modal-body">
                                            <h6 className="mt-2 mb-3 text-dark">Request details -</h6>
                                            <div className="popup-row">  <strong>Request ID</strong> <span>: {franchiseData.request_id}</span> </div>
                                            <div className="popup-row"><strong>Request date</strong> <span>: {new Date(franchiseData.request_created_at).toISOString().split('T')[0]}</span></div>
                                            <div className="popup-row"> <strong>Total licenses </strong> <span>: {franchiseData.total_licenses_count}</span></div>
                                            <div className="popup-row"><strong>Current Licenses </strong> <span>: {franchiseData.available_license}</span></div>
                                            <div className="popup-row"><strong>Request Licenses </strong> <span className="iletreqlicence">: {franchiseData.requested_license_count}</span></div>
                                            <h6 className="mt-3 mb-3 text-dark">Franchise details -</h6>
                                            <div className="popup-row"><strong>Name</strong> <span>: {franchiseData.name}</span></div>
                                            <div className="popup-row"><strong>Phone no</strong> <span>: {franchiseData.phone_number}</span></div>
                                            <div className="popup-row"><strong>Email</strong> <span>: {franchiseData.email}</span></div>
                                            <div className="popup-row"><strong>Company name</strong> <span>: {franchiseData.company_name}</span></div>
                                            <div className="popup-row"><strong>Location</strong> <span>: {franchiseData.state},{franchiseData.city}</span></div>
                                            <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
                                                <button type="button" className="Franchise-denybtn" onClick={() => handleApproveFranchise(franchiseData.request_id, franchiseData.franchise_id, 'Denied')}>
                                                    Denied
                                                </button>
                                                <button type="button" className="Franchise-approvebtn" onClick={() => handleApproveFranchise(franchiseData.request_id, franchiseData.franchise_id, 'Approved')}                          >
                                                    Approve
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isclientpopup && (
                                <div className="popup-overlayreq">
                                    <ToastContainer />
                                    <div className="popup-contentreq">
                                        <p className='text-end mb-0 mt-2'> <FontAwesomeIcon className="Franchise-close" onClick={handleCloseclient} icon={faXmark} /></p>
                                        <h5>Client plan update </h5>
                                        <div className='mt-2' >
                                            <h6 className="mt-2 mb-3 text-dark">Request details -</h6>
                                            <div className="popup-row"><strong>Request ID</strong><span>: {selectedClient.request_id}</span></div>
                                            <div className="popup-row "><strong>Request date</strong><span>:  {new Date(selectedClient.created_at).toISOString().split('T')[0]}</span></div>
                                            <div className='popup-row'>
                                                <strong>Current AI tools</strong>:
                                                <div className='row col-12 clentrows'>
                                                    {selectedClient.tool_camera && Object.entries(selectedClient.tool_camera).map(([key, value]) => {
                                                        const labelName = label.find(item => item.id === parseInt(key))?.label || `ID ${key}`;
                                                        return (
                                                            <div key={key} className='col-12 col-lg-5'>
                                                                {labelName}: {value}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className="popup-row"><strong>Request</strong><span className="iletreqlicence">:  Add additional tool</span></div>
                                            <div className='popup-row'>
                                                <strong>RequestedAI tools</strong>:
                                                <div className='row col-12 clentrows'>
                                                    {selectedClient.requested_plans && Object.entries(JSON.parse(selectedClient.requested_plans)).map(([key, value]) => (
                                                        <div key={key} className='col-12 col-lg-5'>
                                                            {key}: {value}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <h6 className="mt-2 mb-3 text-dark">Client  details  -</h6>
                                            <div className="popup-row"><strong>Client type</strong><span>: {selectedClient.client_type}</span></div>
                                            <div className="popup-row"><strong>Name</strong><span>: {selectedClient.name}</span></div>
                                            <div className="popup-row"><strong>Phone no</strong><span>: {selectedClient.phone_number}</span></div>
                                            <div className="popup-row"><strong>Email</strong><span>: {selectedClient.email}</span></div>
                                            <div className="popup-row"><strong>Location</strong><span>:{selectedClient.country}, {selectedClient.state}, {selectedClient.city}</span></div>
                                            <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
                                                <button type="button" className="Franchise-denybtn" onClick={() => handleApproveclient(selectedClient.request_id, selectedClient.client_id, 'Denied')}>
                                                    Denied
                                                </button>
                                                <button type="button" className="Franchise-approvebtn" onClick={() => handleApproveclient(selectedClient.request_id, selectedClient.client_id, 'Approved')}                          >
                                                    Approve
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
            ))
};

export default Request;
